import { Component } from '@angular/core';
import { ICellRendererParams } from '@ag-grid-community/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { Logger } from '@utils/logger';
/**
 * Logger
 */
const logger = Logger.getLogger('NameCellRendererComponent');

@Component({
  selector: 'ft-checkbox-cell-renderer',
  templateUrl: './checkbox-cell-renderer.component.html',
  styleUrls: ['./checkbox-cell-renderer.component.scss'],
})
export class CheckboxCellRendererComponent implements ICellRendererAngularComp {
  public params!: ICellRendererParams;
  public cellValue: boolean;
  public cellId: string;

  constructor() {
    // Constructor placeholder
  }

  agInit(params: ICellRendererParams): void {
    this.cellValue = params.value;
    this.cellId = params.data.ID + '-' + params.column.getColId();
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  public checkboxChanged($event: boolean) {
    this.params.setValue($event);
    this.params.context.selectionCount(this.cellId);
    logger.debug('Checkbox changed:', $event);
  }
}
